import cn from 'classnames';
import { Grid } from 'ht-styleguide';
import Image from 'next/legacy/image';
import { TECH_QUOTES } from './constants';
import styles from './meetOurTechs.module.scss';

type TechQuoteProps = { quote: { name: string; city: string; text: string } };

const TechQuote = ({ quote }: TechQuoteProps) => (
  <div className={styles.techQuote}>
    <h3>{quote.name}</h3>
    <h5 className={styles.quoteCity}>{quote.city}</h5>
    <div className={styles.stylizedQuotationMark}>&ldquo;</div>
    <p className="p1 n700">{quote.text}</p>
  </div>
);

const MeetOurTechsPage = () => (
  <section>
    <Grid.FullWidth classes={styles.gridHero}>
      <div className={styles.desktopHero}>
        <Image quality={60} src="/_nextassets_/images/meetOurTechsDesktop.jpg" layout="responsive" width={1900} height={572} />
      </div>
      <div className={styles.mobileHero}>
        <Image quality={60} src="/_nextassets_/images/meetOurTechsMobile.jpg" layout="responsive" width={1100} height={635} />
      </div>
    </Grid.FullWidth>
    <Grid.Fluid classes="paddingY-medium1">
      <h1 className={cn('marginBottom-medium2 text-align-center', styles.header)}>Meet Our Techs</h1>
      <div className={styles.quotesBlock}>
        {TECH_QUOTES.map((quote, index) => (
          <TechQuote key={index} quote={quote} />
        ))}
      </div>
    </Grid.Fluid>
  </section>
);

export default MeetOurTechsPage;
